// import React, { useState } from "react";
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import {
//   IoTimeOutline,
//   IoNotifications,
// } from "react-icons/io5";
// import { useHistory } from "react-router-dom";

// import {
//   UNAPPROVED_TRIP_ADVANCE,
//   VEHICLE_UNALLOTTED,
//   VENDOR_UNALLOTTED,
// } from "utils/constant";

// import FranchisePageServices from "services/FranchiseService";
// import getEmployeeId from "utils/commonAdmin";

// dayjs.extend(customParseFormat);

// const OverAllNotifcationCardUI = ({
//   data,
//   from = null,
//   onStatusChange,
//   onDelete,
// }) => {
//   const history = useHistory();

//   const [loadingRead, setLoadingRead] = useState(false);
//   const [loadingDelete, setLoadingDelete] = useState(false);

//   const formattedTime = data?.sent_time
//     ? dayjs(data.sent_time, "DD-MM-YYYY hh:mm A").format(
//         "DD MMM YYYY hh.mm A"
//       )
//     : "";

//   const handleMarkAsRead = async (silent = false) => {
//     if (loadingRead) return;

//     try {
//       setLoadingRead(true);

//       const id_employee = await getEmployeeId();

//       const payload = {
//         status: data?.status === 0 ? 1 : 0,
//         receiver: data?.receiver || id_employee,
//       };

//       await FranchisePageServices.markAsReadNotification(
//         data.id,
//         payload
//       );

//       onStatusChange?.(data.id, payload.status);

//       if (!silent) {
//         console.log("Notification updated.");
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoadingRead(false);
//     }
//   };

//   const handleSingleDelete = async () => {
//     if (loadingDelete) return;

//     try {
//       setLoadingDelete(true);

//       const id_employee = await getEmployeeId();

//       const payload = {
//         receiver: id_employee,
//         ids: [data?.id],
//       };

//       await FranchisePageServices.notificationDelete(payload);

//       onDelete?.(data?.id);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoadingDelete(false);
//     }
//   };

//   const makeNavigation = () => {
//     switch (Number(data?.notification_type)) {
//       case Number(VENDOR_UNALLOTTED):
//         history.push("/VendorAllotment");
//         break;

//       case Number(VEHICLE_UNALLOTTED):
//         history.push("/vehicle-allotment");
//         break;

//       case Number(UNAPPROVED_TRIP_ADVANCE):
//         history.push("/tripadvance-approval");
//         break;

//       default:
//         return;
//     }

//     if (data?.status === 0) {
//       handleMarkAsRead(true);
//     }
//   };

//   return (
//     <div
//       className="group cursor-pointer rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-md"
//       onClick={makeNavigation}
//     >
//       <div className="flex gap-3">
//         <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-50">
//           <IoNotifications className="text-md text-blue-600" />
//         </div>

//         <div className="flex-1">
//           <div className="flex items-start justify-between gap-3">
//             <div className="w-2/3">
//               <h3 className="text-md font-semibold text-gray-800">
//                 Notification
//               </h3>

//               <p className="mt-1 break-words text-sm leading-6 text-gray-500">
//                 {data?.message}
//               </p>
//             </div>

//             <div className="flex w-1/3 items-center justify-end gap-1 whitespace-nowrap text-sm text-gray-400">
//               <IoTimeOutline className="text-sm" />
//               <span>{formattedTime}</span>
//             </div>
//           </div>

//           {from === "all" && (
//             <div className="mt-3 flex justify-end gap-3">
//               <button
//                 type="button"
//                 disabled={loadingDelete}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleSingleDelete();
//                 }}
//                 className={`rounded-md px-3 py-1 text-sm font-medium text-red-600 transition-colors hover:text-red-700 ${
//                   loadingDelete
//                     ? "cursor-not-allowed opacity-50"
//                     : ""
//                 }`}
//               >
//                 {loadingDelete ? "Deleting..." : "Delete"}
//               </button>

//               <button
//                 type="button"
//                 disabled={loadingRead}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleMarkAsRead();
//                 }}
//                 className={`rounded-md px-3 py-1 text-sm font-medium transition-colors ${
//                   data?.status === 0
//                     ? "text-green-600 hover:text-green-700"
//                     : "text-yellow-600 hover:text-yellow-700"
//                 } ${
//                   loadingRead
//                     ? "cursor-not-allowed opacity-50"
//                     : ""
//                 }`}
//               >
//                 {loadingRead
//                   ? "Updating..."
//                   : data?.status === 0
//                   ? "Read"
//                   : "Unread"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OverAllNotifcationCardUI;


import React, { useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  IoTimeOutline,
  IoNotifications,
} from "react-icons/io5";
import { useHistory } from "react-router-dom";

import {
  UNAPPROVED_TRIP_ADVANCE,
  VEHICLE_UNALLOTTED,
  VENDOR_UNALLOTTED,
} from "utils/constant";

import FranchisePageServices from "services/FranchiseService";
import getEmployeeId from "utils/commonAdmin";
import NotificationServices from "services/NotificationServices";

dayjs.extend(customParseFormat);

const OverAllNotifcationCardUI = ({
  data,
  from = null,
  onStatusChange,
  onDelete,
}) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const formattedTime = data?.sent_time
    ? dayjs(
      data.sent_time,
      "DD-MM-YYYY hh:mm A"
    ).format("DD MMM YYYY hh.mm A")
    : "";

  const handleMarkAsRead = async (silent = false) => {
    if (loading) return;

    try {
      setLoading(true);

      const id_employee = await getEmployeeId();

      const payload = {
        status: data?.status === 0 ? 1 : 0,
        receiver: data?.receiver || id_employee,
      };

      await NotificationServices.markAsReadNotificationNew(
        data.id,
        payload
      );

      onStatusChange?.(
        data.id,
        payload.status
      );

      if (!silent) {
        console.log("Notification Updated");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (loading) return;

    try {
      setLoading(true);

      const id_employee = await getEmployeeId();

      const payload = {
        receiver: id_employee,
        ids: [data.id],
      };

      await NotificationServices.notificationDeleteNew(
        payload
      );

      onDelete?.(data.id);

      console.log("Notification Deleted");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const makeNavigation = async () => {
    if (loading) return;

    if (data?.status === 0) {
      await handleMarkAsRead(true);
    }

    switch (Number(data?.notification_type)) {
      case Number(VENDOR_UNALLOTTED):
        history.push("/VendorAllotment");
        break;

      case Number(VEHICLE_UNALLOTTED):
        history.push("/vehicle-allotment");
        break;

      case Number(UNAPPROVED_TRIP_ADVANCE):
        history.push("/tripadvance-approval");
        break;

      default:
        break;
    }
  };

  return (
    <div
      className="group cursor-pointer rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all duration-300 hover:shadow-md"
      onClick={makeNavigation}
    >
      <div className="flex gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-50">
          <IoNotifications className="text-md text-blue-600" />
        </div>

        <div className="flex-1">
          <div className="flex items-start justify-between gap-3">
            <div className="w-2/3">
              <h3 className="text-md font-semibold text-gray-800">
                Notification
              </h3>

              <p className="mt-1 break-words text-sm leading-6 text-gray-500">
                {data?.message}
              </p>
            </div>

            <div className="flex w-1/3 items-center justify-end gap-1 whitespace-nowrap text-sm text-gray-400">
              <IoTimeOutline className="text-sm" />
              <span>{formattedTime}</span>
            </div>
          </div>

          {from === "all" && (
            <div className="mt-3 flex justify-end gap-4">
              <button
                type="button"
                disabled={loading}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete();
                }}
                className={`rounded-md px-3 py-1 text-sm font-medium text-red-600 hover:text-red-700`}
              >
                {"Delete"}
              </button>

              <button
                type="button"
                disabled={loading}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMarkAsRead();
                }}
                className={`rounded-md px-3 py-1 text-sm font-medium transition-colors ${data?.status === 0
                    ? "text-green-600 hover:text-green-700"
                    : "text-yellow-600 hover:text-yellow-700"
                  } ${loading
                    ? "cursor-not-allowed opacity-50"
                    : ""
                  }`}
              >
                {loading
                  ? "Updating..."
                  : data?.status === 0
                    ? "Read"
                    : "Unread"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverAllNotifcationCardUI;